import { render, staticRenderFns } from "./AdiPaiRisultatiObiettiviComponent.vue?vue&type=template&id=311596ac"
import script from "./AdiPaiRisultatiObiettiviComponent.vue?vue&type=script&lang=js"
export * from "./AdiPaiRisultatiObiettiviComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports